import { Injectable } from '@angular/core';
import { Benefits } from '../models/benefts.interface';
import { firstValueFrom } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReporteService {
  constructor(private httpClient: HttpClient) {}

  async listar_detalle_solicitudes_usuarios(fecha_desde?: string, fecha_hasta?: string, criterio_busqueda?: string, pagina: Number = 1): Promise<any> {
    return firstValueFrom<any[]>(
      this.httpClient.get<any[]>(enviroment.url + `reporte/${fecha_desde}/${fecha_hasta}/${pagina}/${criterio_busqueda}/det_sol_usuarios`),
    );
  }

  async listar_beneficiarios_seguro_complementario(fecha_inicio?: string, fecha_termino?: string): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.get<any>(enviroment.url + `solicitud/${fecha_inicio}/${fecha_termino}/beneficiarios-seguro-complementario`),
    );
  }

  async generar_rpt_detalle_solicitudes_usuarios(): Promise<any> {
    return firstValueFrom<any[]>(
      this.httpClient.get<any[]>(enviroment.url + `reporte/det_sol_usuarios/descargar`),
    );
  }

  async listar_detalle_solicitudes_by_id(id_beneficio: number,fecha_desde: string, fecha_hasta: string): Promise<any> {
     let params = new HttpParams();
     params = params.set('id_beneficio', id_beneficio);
     params = params.set('fecha_desde', fecha_desde);
     params = params.set('fecha_hasta', fecha_hasta);
      return firstValueFrom<any[]>(
        this.httpClient.get<any[]>(enviroment.url + `reporte/solicitudes`,{params}),
    );
  }
}
